export class VehicleGroup{
    vehGrpId:number;
}
